export const ProjectStatuses = {
  STATUS_STARTED: { id: 'STATUS_STARTED', label: 'In progress' },
  STATUS_FAILED: { id: 'STATUS_FAILED', label: 'Error' },
  STATUS_FINISHED: { id: 'STATUS_FINISHED', label: 'Ready' },
  STATUS_STOPPED: { id: 'STATUS_STOPPED', label: 'Stopped' },
  STATUS_QUEUED: { id: 'STATUS_QUEUED', label: 'In progress' },
  STATUS_NOT_TRAINED: { id: 'STATUS_NOT_TRAINED', label: 'Ready to Analyze' },
}
